module.exports = __webpack_public_path__ + "static/media/veca.7ccdcc11.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/veca.png
// module id = 342
// module chunks = 0